<template>
  <div>
      <header>
          <div class="headerOne">
               <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
                <span class="buss">{{msg}}</span>
          </div>
      </header>
      <div>
        <!-- 普通消息 -->
         <ul  v-if="this.type==0 ? true:false">
   
            <li v-for="(item,index) in content" :key="index">
              <span >{{item.l}}</span>
              <!-- <span class="addNum">x1</span> -->
              <span class="flortRight">{{item.r}}</span>
            </li>
           </ul>
        <!-- 消费通知 -->
        <ul  v-if="this.type==2 ? true:false">          
            <li v-for="(item,index) in content" :key="index">
              <span>{{item.l}}</span>
              <!-- <span class="addNum">x1</span> -->
              <span class="flortRight">{{item.r}}</span>
            </li>
           </ul>
           <!-- 充值成功 -->
          <ul v-if="this.type==1 ? true:false">
         
            <li v-for="(item,index) in content" :key="index">
               <span>{{item.l}}</span>
                <!-- <span class="addNum">x1</span> -->
               <span class="flortRight">{{item.r}}</span>   
            </li>
          </ul>
          <!-- 退款成功 -->
          <ul v-if="this.type==4 ? true:false">
        
            <li v-for="(item,index) in content" :key="index">
              <span>{{item.l}}</span>
              <!-- <span class="addNum">x1</span> -->
              <span class="flortRight">{{item.r}}</span>
            </li>
          </ul>
          <!-- 系统消息 -->
          <ul v-if="this.type==3 ? true:false">     
     
            <li v-for="(item,index) in content" :key="index">
              <span>{{item.l}}</span>
              <!-- <span class="addNum">x1</span> -->
              <span class="flortRight">{{item.r}}</span>
            </li>
          </ul>  
      </div>

  </div>
</template>
<script>
import axios from "axios";
import { Popup ,Toast } from 'mint-ui';
export default {
  data() {
    return {
      msg: "消息详情",
      content: "",
      sendTime: "",
      subject: "",
      content: [],
      type: "",
      sender:"",
      Toast: Toast({
          message: '加载中...',
          position: 'middle',
          duration: -1
        }),
    };
  },
  computed: {
    wsWbsocket() {
      return this.$store.state.wsWbsocket;
    }
  },
  methods: {
    checkHttpReturn(id)
    {
                if(httpSendQue[id]==0)
                {
                    var  self=this;
                    setTimeout(() => {
                            if (self && !self._isDestroyed)
                                self.checkHttpTimeOut();
                        }, newConfigTime);

                }
                else
                {
                    delete httpSendQue[id];
                }
            },
    checkHttpTimeOut()
    {
        if(httpSendQue[id]==0)
        {
            //  隐藏加载中
              this.Toast.close()
              Toast({
                    message: '网络不给力',
                    position: 'middle',
                    duration: 3000
                  })
              

        }
        else
        {
            //删除数组中的id
            delete httpSendQue[id];

        }
    },
    websocketOne() {
      let isRead = this.$route.query.isRead;
      var  self=this;     
            id= getHttpSendId ();
            getArry(id)   //将生成ID放入数组  
            setTimeout(() => 
            {
                if (self && !self._isDestroyed)
                    self.checkHttpReturn(id);
            }, configTime);      
      axios.get(detailInformation+"&uid="+uid+"&sign="+sign+"&mode="+mode+"&msgId="+isRead)
        .then(res=>{  
              httpSendQue[id] = 1; 
              this.Toast.close();
              if(res.data.s==0){
                console.log("消息详情",res.data)
                this.type = res.data.type;
                // console.log(this.type);
                 var contentArr = JSON.parse(res.data.content);
                 console.log(contentArr)
                  this.content = contentArr.items;
                  this.sendTime = res.data.sendTime;
                  this.subject =res.data.subject;
                  this.sender= res.data.sender;
                  console.log( res.data.sender)
                }
              })
        .catch(error=>{
              this.Toast.close()
                        Toast({
                            message: '网络不给力',
                            position: 'middle',
                            duration:2000
                          })       
                    })
    
    }
  },
   created() {

  },
  mounted(){
        this.websocketOne();
  },
  destroyed()
    {
    this.Toast.close()
   
    }
};
</script>
<style scoped>

.el-icon-arrow-left{
    font-size: 0.75rem;
    line-height:1.6rem;
     margin-left: 0.2rem
}
.lastLi {
  margin-top: 0.2rem !important;
}
.addNum {
  margin-left: 2.2rem;
}
.addNumtwo {
  margin-left: 2.37rem;
}
div ul li {
  color: rgba(0, 0, 0, 1);
  font-size: 0.55rem;
  width: 90%;
  margin: 0 auto;
  margin-top: 0.3rem;
  height: 0.8rem;
  line-height: 0.8rem
}
div ul li span {
  margin-top: 0;
  color: rgba(0, 0, 0, 0.6)
}
div ul li:nth-child(1) span:nth-child(1){
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.6rem
}
div ul li:nth-child(1) span:nth-child(2){
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.5rem
}
div ul li:nth-child(3) span:nth-child(1){
  color: black;
  font-size: 0.5rem
}
/* div ul li span:nth-child(2){
float: right
} */
.flortRight {
  float: right;
  display: inline-block;
}
div ul li:nth-child(1) {
  font-size: 0.55rem;
  color: rgba(0, 0, 0, 0.9);
  margin-top: 0.4rem;
  margin-bottom: 0.1rem;
}

div ul li:nth-child(6) {

}

p {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.55rem;
  width: 90%;
  margin: 0 auto;
  text-align: center;
  margin-top: 1.5rem;
}
header {
  height: 1.6rem;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  position: relative;
}
.headerOne {
  font-size: 0;
}
.headerOne img {
  display: inline-block;
  margin-top: 0.3rem;
}
.headerOne img:nth-child(1) {
  margin-left: 0.2rem;
}
.headerOne .buss {
  display: inline-block;
  font-size: 0.55rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* font-family: "PingFangHK-Regular"; */
}
</style>



// WEBPACK FOOTER //
// src/components/change/detailOne.vue